import { useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';

import styles from './index.module.scss';

const cx = classNames.bind(styles);

const S02 = () => {
  const [isOverlap, setOverlap] = useState(true);
  const observeRef = useRef();

  useEffect(() => {
    if (observeRef.current) {
      const observer = new IntersectionObserver((entry) => {
        setOverlap(entry[0].isIntersecting);
      });
      observer.observe(observeRef.current);
    }
  }, []);

  return (
    <section className={cx('container')}>
      {/* <p className={cx(['desc', isOverlap && 'enable'])}>
        르브레는 화장품 연구원, 마케터, 디자이너인 엄마아빠가 모여 <br />
        아이들을 위해 진심을 담아 만든 프리미엄 키즈 비건 코스메틱 브랜드입니다.
      </p> */}
      <div ref={observeRef} className={cx('observe')} />
    </section>
  );
};

export default S02;
